import React from "react"
import {Api} from "../api";
import {Badge} from "reactstrap";



interface ShortcutProps {
  queries?: string[],
  link: string,
  title:string,
  icon: string,
  iconColor?: string,
  refreshPeriod?:number
}

class Shortcut extends React.Component<ShortcutProps, any> {

  state = {
    bubbleData: [{}],
    showBubble: false
  };

  bubbleData = [{}];

  componentDidMount(): void {
    if(this.props.queries != null && this.props.queries.length > 0) {
      this.setUpInterval();
    }
  }

  setUpInterval() {
    const period = Math.max(3, this.props.refreshPeriod!);
    const queryTimer = setInterval(this.executeQuery.bind(this), period! * 1000);
    this.setState({queryTimer});
    this.executeQuery();
  }

  executeQuery() {
    if(this.props.queries != null) {
      this.bubbleData = [];
      for(let query of this.props.queries) {
        Api.query(query)
          .then(res => {
            for(let row of res) {
              this.bubbleData.push({name:row.name, value:row.value as any, color: row.color[0] as any});
            }
            this.setState({bubbleData: this.bubbleData, showBubble: true});
          }).catch(error => this.setState({fetchError: error}));
      }
    }
  }

  getBubbles() {
      let bubbles;
      bubbles = this.state.bubbleData.map((value, index) => {
        return (<Badge className="alert-bubble" key={index} style={{backgroundColor: ((typeof ((value as any).color) === 'string' ) ? (value as any).color : 'var(--accentColor)')}}>{(value as any).value}</Badge>);
      });
      return bubbles;
  }

  render() {
    return (
      <a href={this.props.link}>
        <div className="mainitem" style={{position:'relative'}} title={this.props.title}>
          <i className={this.props.icon} style={{color:this.props.iconColor ? this.props.iconColor : ""}} ></i>
          <span className="item-text">
            {this.props.title}
          </span>
          {this.state.showBubble &&
          this.getBubbles()}
        </div>
      </a>
    );
  }
}
export default Shortcut